<template>
  <section class="fms-header">
    <div>
      <h1>{{ currAsset.massName }} - Dashboard FMS</h1>
      <div class="overview-tags">
        <span class="fms-tag">{{ currAsset?.massMaty?.matyName ?? '-' }}</span>
        <span class="fms-tag fms-tag--soft">24H Overview</span>
        <span class="fms-tag fms-tag--outline">{{ rangeLabel }}</span>
      </div>
    </div>
    <div class="header-status">
      <span class="status-pill" :class="{ 'status-pill--alert': !isRealtimeConnected }">
        <span class="status-dot" :class="{ 'status-dot--alert': !isRealtimeConnected }"></span>
        {{ isRealtimeConnected ? 'Realtime Connected' : 'Disconnected' }}
      </span>
      <span class="status-date">Last Data: {{ currAssetLastData?.gps?.timestamp }}</span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FmsHeader',
  props: {
    currAsset: {
      type: Object,
      required: true,
    },
    currAssetLastData: {
      type: Object,
      default: null,
    },
    isRealtimeConnected: {
      type: Boolean,
      default: false,
    },
    rangeLabel: {
      type: String,
      default: '',
    },
    deviceStatus: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
};
</script>

<style scoped>
.fms-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px 16px;
  flex-wrap: wrap;
  gap: 15px;
}

.fms-header h1 {
  font-size: var(--mz-fs-xl);
  font-weight: 700;
  margin: 0 0 6px;
  color: var(--mz-text-emphasis);
}

.overview-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.header-status {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: var(--mz-fs-sm);
  color: var(--mz-text-subtle);
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #e9f9ef;
  color: #2a9d55;
  padding: 4px 10px;
  border-radius: 20px;
  font-weight: 600;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2a9d55;
}

.status-pill--alert {
  background: #fee2e2;
  color: #b91c1c;
}

.status-dot--alert {
  background: #ef4444;
}

.status-dot-green {
  background: #29c56a;
}

@media screen and (max-width: 991px) {
  .fms-header {
    padding: 10px 10px 16px;
  }
}
</style>
